
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";
  import debounce from "lodash-es/debounce";

  import FormAsyncselect from "@/components/form/FormAsyncselect.vue";

  import DropdownOption from "@/entities/DropdownOption";
  import DropdownGroupOption from "@/entities/DropdownGroupOption";

  @Component({
    components: {
      FormAsyncselect,
    },
  })
  export default class DropdownFilter extends Vue {
    @Prop({ type: Array, required: true }) readonly options!: any[];
    @Prop({ type: String, default: "Start typing" }) readonly noOptionsText?: string;
    @Prop({ type: String, default: "Select item" }) readonly placeholder!: string;
    @Prop({ type: Array, default: () => [] }) readonly value!: DropdownOption[] | DropdownGroupOption[];
    @Prop({ type: Boolean, default: true }) readonly multiple!: boolean;
    @Prop({ type: String, default: "" }) readonly selectLabel!: string;
    @Prop({ type: String, default: "" }) readonly deselectLabel!: string;
    @Prop({ type: Boolean, default: false }) readonly invalid!: boolean;
    @Prop({ type: Boolean, default: false }) readonly loading!: boolean;
    @Prop({ type: Boolean, default: false }) readonly withoutLoading!: boolean;
    @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
    @Prop({ type: Boolean, default: true }) readonly searchable!: boolean;
    @Prop({ type: Number, default: undefined }) readonly max?: number;
    @Prop({ type: String, default: undefined }) readonly trackBy?: string;
    @Prop({ type: String, default: undefined }) readonly groupLabel?: string;
    @Prop({ type: String, default: undefined }) readonly groupValues?: string;
    @Prop({ type: Boolean, default: false }) readonly groupSelect!: boolean;

    searchQuery: string = "";
    loadingProcess: boolean = false;

    @Watch("loading")
    onLoadingChange() {
      if (!this.loading) {
        this.loadingProcess = false;
      }
    }

    get isLoading(): boolean {
      if (this.withoutLoading) {
        return false;
      }
      return this.loadingProcess && !!this.searchQuery.length;
    }

    get optionsList(): any[] {
      const searchEmpty = this.searchQuery.length === 0;

      if (!this.withoutLoading && this.isLoading) {
        return [];
      }
      return this.options;
    }

    get noResults(): boolean {
      return (!!this.searchQuery.length && !this.options.length) || this.isLoading;
    }

    handleSearch(query: string) {
      this.searchQuery = query;
      this.loadingProcess = true;

      debounce(this.updateSearch, 500)();
    }

    updateSearch(): void {
      this.$emit("search", this.searchQuery);
    }

    handleInput(value: DropdownOption[]): void {
      this.$emit("input", value);
    }
  }
